import { useQuery } from 'react-query';

import { invoiceService } from '@project/services';

export const useIndividualPaidInvoices = (filter: string[], active = false) => {
  return useQuery(
    ['getIndividualPaidInvoices', filter],
    () => invoiceService.fetchIndividualPaidInvoices(filter),
    { enabled: active },
  );
};
